import { createMuiTheme, responsiveFontSizes } from '@material-ui/core'
import { each } from 'lodash'

export const palette = {
  primary: {
    main: '#05a8a4',
    light: '#47a8bd',
    dark: '#03908d',
    contrastText: '#fff',
  },
  secondary: {
    main: '#D2007E',
    light: '#FBE6F3',
    300: '#ED0690',
    contrastText: '#fff',
  },
}

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  overrides: {
    MuiGrid: {
      root: {
        margin: 0,
      },
      'spacing-xs-1': { margin: 0 },
      'spacing-xs-2': { margin: 0 },
      'spacing-xs-3': { margin: 0 },
      'spacing-xs-4': { margin: 0 },
      'spacing-xs-5': { margin: 0 },
      'spacing-xs-6': { margin: 0 },
      'spacing-xs-7': { margin: 0 },
      'spacing-xs-8': { margin: 0 },
      'spacing-xs-9': { margin: 0 },
      'spacing-xs-10': { margin: 0 },
      'spacing-xs-11': { margin: 0 },
      'spacing-xs-12': { margin: 0 },
    },
    MuiLinearProgress: {
      root: {
        height: 6,
      },
    },
    MuiInputLabel: {
      root: {
        zIndex: 0,
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.9rem',
        backgroundColor: 'rgba(97, 97, 97, 1)',
      },
    },
    MuiTypography: {
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 700 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 700 },
      body1: { fontWeight: 600, marginBottom: 12 },
      subtitle1: { fontWeight: 600 },
      subtitle2: { color: '#81858b', fontWeight: 400 },
    },
    MuiButton: {
      sizeLarge: {
        minWidth: '128px',
        maxWidth: '240px',
        maxHeight: '46px',
      },
    },
  },
  palette,
})

const coef = 0.05
const modifyRem = (value, coef) => {
  return `${parseFloat(value) * (1 + coef)}rem`
}

each(theme.typography, (variant, variantName) => {
  if (typeof variant !== 'object') {
    return variant
  }
  theme.typography[variantName] = {
    ...variant,
    fontSize: modifyRem(variant.fontSize, -coef * 1.25),
    [theme.breakpoints.up('sm')]: {
      fontSize: modifyRem(variant.fontSize, -coef * 1),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: modifyRem(variant.fontSize, -coef * 0.6),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: modifyRem(variant.fontSize, 0),
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: modifyRem(variant.fontSize, coef),
    },
  }
})

export default responsiveFontSizes(theme)
